/**
 * ThemedShell — wires `DomainContext` into the hestia ThemeProvider and
 * mirrors the active domain's `display_name` into `document.title`.
 *
 * T9 F3.1 introduced the `brand` plumbing; T9 F3.5 added the document
 * title sync (spec §5.9) so every domain's tab name matches its public
 * brand instead of the static "Ariadne" placeholder shipped in
 * `index.html`. The placeholder remains for the pre-React paint; this
 * component overwrites it as soon as the provider resolves a profile.
 *
 * Extracted from `main.tsx` into its own module so it can be exercised
 * directly by tests (otherwise `main.tsx` would need to mount the entire
 * provider stack including QueryClient, Cerberus, Router, etc.).
 */
import { useEffect, type ReactNode } from 'react'
import { ThemeProvider } from '@francisquiniai/hestia-web'
import { useDomain } from './context'

interface ThemedShellProps {
  children: ReactNode
}

export function ThemedShell({ children }: ThemedShellProps) {
  const { brand, display_name } = useDomain()
  useEffect(() => {
    document.title = display_name
  }, [display_name])
  return (
    <ThemeProvider theme="light" brand={brand}>
      {children}
    </ThemeProvider>
  )
}
